import { isUndefined } from 'util';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import template from './estimatedQuote.vue';

@Component({
    mixins: [template],
    components: {},
})
export default class EstimatedQuoteLastMile extends Vue {
    quoteData = this.$store.getters.quoteData;

    isEditMode: boolean = false;
    isScheduleMode: boolean = false;
    isShowButtons: boolean = true;

    get ROCSum() {
        return parseFloat(this.quoteData.estimate.ROC) || 0;
    }
    get WGSum() {
        return parseFloat(this.quoteData.estimate.WG) || 0;
    }

    created() {
        let query = this.$route.query;

        this.isEditMode = query.isEdit ? true : false;
        this.isScheduleMode = query.schedule ? true : false;
        if (!isUndefined(query.isShowButtons)) {
            this.isShowButtons = query.isShowButtons === 'false' ? false : true;
        }
    }

    schedulePickup() {
        this.$emit('schedulePickup');
    }

    saveQuote() {
        this.$emit('saveQuote');
    }

    editQuote() {
        this.$emit('goEdit');
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/estimatedQuoteLastMile/index.ts